import { axiosClient } from "../axios";
import { getQuery } from "../helper";

const dsrBaseUrl = "/api/esg/dsr";
const firmBaseUrl = "/api/registry/firms";

/**
 * Stato delle licenze della firm chiamante. È un GET: resta accessibile anche in sola lettura.
 * Il ROOT non appartiene a una firm e deve passare firmId.
 */
export function getLicenseState(firmId = null) {
  const query = getQuery({ firmId });
  return axiosClient.get(`${dsrBaseUrl}/license-state`, query);
}

export function getFirmLicenses(firmId) {
  return axiosClient.get(`${firmBaseUrl}/${firmId}/dsr-licenses`);
}

export function registerSubscriptionYear(firmId, data) {
  return axiosClient.post(`${firmBaseUrl}/${firmId}/dsr-licenses`, data);
}

export function removeSubscriptionYear(firmId, yearId) {
  return axiosClient.delete(`${firmBaseUrl}/${firmId}/dsr-licenses/${yearId}`);
}

export function releaseSlot(firmId, enterpriseId, year) {
  return axiosClient.delete(
    `${firmBaseUrl}/${firmId}/dsr-licenses/slots/${enterpriseId}/${year}`
  );
}
